import { api, AUTH_ROLE_KEY, isAdminRole } from "../services/apiClient";

export function canUseUserFilter() {
  return isAdminRole(localStorage.getItem(AUTH_ROLE_KEY));
}

export function userQuery(userId) {
  return userId ? `?userId=${encodeURIComponent(userId)}` : "";
}

export function userLabel(user) {
  return user?.username || user?.email || user?.id || "Không rõ";
}

export async function fetchUserOptions() {
  const users = (await api.get("/api/users/options")) || [];
  return users.map((user) => ({ value: user.id, label: userLabel(user), username: user.username }));
}
